import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { LoadingController, ToastController, ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';

import { WhatsappService } from 'src/app/services/whatsapp.service';
import { ValidarToken } from 'src/app/validators/valida-datos';
import { MdlFiltroPage } from 'src/app/pages/mdl-filtro/mdl-filtro.page';

@Component({
  selector: 'app-reporte-registro-inicio-sesion',
  templateUrl: './reporte-registro-inicio-sesion.component.html',
  styleUrls: ['./reporte-registro-inicio-sesion.component.scss'],
})
export class ReporteRegistroInicioSesionComponent implements OnInit {

  idAdmin: string;
  vista: number;
  fechaInicial: any;
  fechaFinal: any;
  loading: any;
  agentes: any;
  arrAgentes: any;
  classUser: any;
  totalFiltro: number;
  banderaNum: any;
  inicio: any;
  fin: any;
  sesiones: any;
  nombreAgente: string;

  canal: any;
  canales: any;
  canalInicial: any;
  arrFiltro: any;
  dataFiltro: any;

  constructor(
    private storage: Storage,
    private serviceWa: WhatsappService,
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    private formatdate: DatePipe,
    private modalCtrl: ModalController,
  ) {
    this.canales = [];
    this.fechaFinal = new FormControl('');
    this.fechaInicial = new FormControl('');
    this.sesiones = [];
    this.nombreAgente = '';
    this.arrFiltro = {
      estado: [],
      agentes: [],
      resultados: [],
      origen: [],
      equipo: []
    };
    this.dataFiltro = {
      agente: [],
      numero: '',
      resultado: [],
      origen: [],
      equipo: [],
      estado: [],
    };
  }

  ngOnInit() {
    this.vista = 0;
    this.agentes = [];
    this.arrAgentes = [];
    this.getCanal();
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
    // console.log(this.canales, 'canales ');
    this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec == this.canal.idAdmin_sec);
    this.idAdmin = this.canalInicial.canale.idAdmin_sec;
    this.classUser = this.canalInicial;
    this.getToday();
    // console.log(this.canal.url_back, 'url de back desde storage');
  }

  consulta(val, num) {
    this.presentLoading('Cargando Reporte de efectividad...');
    let query = `admin=${this.idAdmin}`;
    if (val === 1) {
      const feIn = new Date(this.fechaInicial.value);
      const feFin = new Date(this.fechaFinal.value);
      feIn.setHours(0, 0, 0);
      feFin.setHours(23, 59, 59);
      // console.log(feIn);
      // console.log(feFin);
      query = `admin=${this.idAdmin}&inicio=${feIn}&fin=${feFin}`;
    }
    // console.log(query);
    this.serviceWa.getReporteEfectividad(query, this.classUser.id, this.classUser.rol,
      this.classUser.token, this.classUser.canale.url_back).subscribe(
        (res: any) => {
          // console.log(res);
          this.loading.dismiss();

          const { status, message } = res;
          if (status === 'success') {
            const { agentes } = res;
            this.agentes = agentes;
            //console.log(this.agentes);
            this.formatTable(this.agentes);
            this.presentToast('Datos encontrados!', 'success');
            this.vista = 1;
          }
          else {
            this.presentToast('No se encontrarón conversaciones', 'danger');
          }
        },
        erro => {
          console.log(erro);
          this.loading.dismiss();
        });

  }

  formatTable(agentes) {
    this.arrAgentes = agentes.map((agente) => {
      if (agente.agente && agente) {

        return {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Usuario del Agente': agente.agente.usuario,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          Nombre: `${agente.agente.nombre} ${agente.agente.apellido}`,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Total de Chats': agente.conversaciones['COUNT(`conversacion`)'],
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Total de Chats Calificados': agente.calificado,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Total de Chats no Calificados': agente.noCalif,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Total de Chats Otra Respuesta': agente.otraCalif,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Promedio de Calificación': (agente.conversaciones['SUM(`calificacion`)']) / agente.calificado
        };
      }
    });
  }

  formatTableSesion(sesiones) {
    this.arrAgentes = sesiones.map((sesion) => {
      console.log(sesion, 'sesion');
      if (sesion.agente && sesion) {
        return {
          // eslint-disable-next-line @typescript-eslint/naming-convention, quote-props
          'Nombre': `${sesion.agente.nombre} ${sesion.agente.apellido}`,
          // eslint-disable-next-line @typescript-eslint/naming-convention, quote-props
          'Rol': sesion.agente.rol,
          // eslint-disable-next-line @typescript-eslint/naming-convention, quote-props
          'Estado de Agente': (sesion.status_agente !== '') ? sesion.status_agente : '-',
          // eslint-disable-next-line @typescript-eslint/naming-convention, quote-props
          'Fecha de Cambio': (sesion.fecha_estatus !== null) ? this.formatdate.transform(sesion.fecha_estatus, 'dd/MM/yyyy HH:mm:ss') : '-',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Inicio Sesión': this.formatdate.transform(sesion.inicio_sesion, 'dd/MM/yyyy HH:mm:ss'),
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Cerró Sesión': (sesion.fin_de_sesion && sesion.fin_de_sesion !== '')
            ? this.formatdate.transform(sesion.fin_de_sesion, 'dd/MM/yyyy HH:mm:ss')
            : 's/n cierre',
        };
      }
      return {};
    });
  }

  descargar() {
    const fechaInicioDate = new Date(this.fechaInicial.value);
    const fechaFinDate = new Date(this.fechaFinal.value);
    const MILISEGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;
    const diferenciaDias = (fechaFinDate.getTime() - fechaInicioDate.getTime()) / MILISEGUNDOS_POR_DIA;

    if (diferenciaDias <= 90) {
      this.formatTableSesion(this.sesiones);
      this.serviceWa.exportAsExcelFile(this.arrAgentes, `Reporte-Inicio-Sesión_${this.formatdate.transform(new Date(), 'dd-MM-yyyy')}`);
    } else {
      this.presentToast('No se puede realizar una descarga mayor a 3 meses', 'danger');
    }
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner: 'dots',
      //message: mensaje,
      cssClass: 'loaderGeneral',
      message: '<ion-img src="../../../assets/images/logoVabelLoading.png"></ion-img>'
    });
    await this.loading.present();
  }

  getToday() {
    const dateIn = new Date();
    const datefin = new Date();
    dateIn.toUTCString();
    datefin.toUTCString();

    dateIn.setHours(0, 0, 0);
    datefin.setHours(23, 59, 59);

    this.inicio = dateIn.toJSON();
    this.fin = datefin.toJSON();
    this.getSesiones();
  }

  busqueda(ev) {
    this.nombreAgente = ev.detail.value;
  }

  getSesiones() {
    if (this.fechaFinal.value && this.fechaInicial.value) {
      let feIn = new Date(this.fechaInicial.value);
      let feFin = new Date(this.fechaFinal.value);

      feIn.toUTCString();
      feFin.toUTCString();
      const dayIn = feIn.getUTCDate();
      const dayFin = feFin.getUTCDate();

      feIn.setUTCDate(dayIn + 1);
      feFin.setUTCDate(dayFin + 1);

      feIn.setHours(0, 0, 0);
      feFin.setHours(23, 59, 59);

      this.inicio = feIn;;
      this.fin = feFin;
    }
    let query = `inicio=${this.inicio}&fin=${this.fin}`;
    const bodyDeAgentes = {
      agentes: this.dataFiltro.agente || []
    };

    this.serviceWa.getSesiones(
      query,
      this.idAdmin,
      this.classUser.id,
      this.classUser.rol,
      this.classUser.token,
      bodyDeAgentes,
      this.classUser.canale.url_back
    ).subscribe(
      (res: any) => {
        const { status } = res;

        if (status === 'success') {
          const { sesiones } = res;
          console.log('Respuesta COMPLETA del back-end:', res);
          console.log('Datos de SESIONES:', sesiones);
          this.sesiones = sesiones;
          this.presentToast('Datos encontrados!', 'success');
          console.log(this.sesiones, 'sesiones');
        }
        else {
          this.presentToast('No se encontrarón sesiones', 'danger');
          //console.log('No se encontrarón sesiones', res);
        }
      },
      (erro: any) => {
        //console.error('Error en la llamada getSesiones:', erro);
        this.loading.dismiss();
      });
  }

  trackBySesion(index: number, sesion: any) {
    return sesion.id || index; // adapta al identificador real
  }


  async presentToast(message, color) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color
    });
    toast.present();
  }

  async openMdlFiltro() {
    let id;
    const modal = await this.modalCtrl.create({
      component: MdlFiltroPage,
      componentProps: {
        dataInfo: this.classUser,
        arrFiltro: this.arrFiltro,
        reporte: 4
      },
      mode: 'ios',
      cssClass: 'modalFiltro'
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();
    this.arrFiltro = data.filtro;
    if (data.filtro.agentes.length > 0) {
      this.dataFiltro.agente = data.filtro.agentes;
    } else {
      this.dataFiltro.agente = [];
    }
    this.dataFiltro.resultado = [];
    this.dataFiltro.origen = [];
    this.dataFiltro.equipo = [];
    this.dataFiltro.estado = [];
    this.totalFiltro = data.filtro.agentes.length;
  }

  resetFiltros() {
    this.fechaInicial.setValue('');
    this.fechaFinal.setValue('');
    this.arrFiltro.agentes = [];
    this.dataFiltro.agente = [];
    this.totalFiltro = 0;
    this.nombreAgente = '';
  }
}
